import React, { useMemo } from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
} from '@mui/material';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';

const normalize = (value) => (value || '').trim().toLowerCase();

const ConfirmActivateDialog = ({
  open,
  onClose,
  onConfirm,
  confirmationText,
  setConfirmationText,
  errorText,
  stationName,
  positionName,
  periodLabel,
  loading = false,
}) => {
  const isValid = useMemo(
    () => normalize(confirmationText) === 'reactivar',
    [confirmationText]
  );

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box sx={{ width: 38, height: 38, borderRadius: 2, display: 'grid', placeItems: 'center', bgcolor: 'rgba(46,125,50,0.14)' }}>
            <LockOpenOutlinedIcon sx={{ color: 'success.main' }} />
          </Box>
          <Box>
            <Typography variant="h6">Reactivar calendario</Typography>
            <Typography variant="body2" color="text.secondary">
              El calendario volverá a estar disponible para edición.
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          Solo los usuarios SuperAdmin pueden realizar esta acción.
        </Alert>
        {(stationName || positionName || periodLabel) && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">Calendario a reactivar:</Typography>
            {positionName && <Typography variant="body1" sx={{ fontWeight: 700 }}>{positionName}</Typography>}
            <Typography variant="body2" color="text.secondary">
              {stationName ? `Estación: ${stationName}` : ''}
              {stationName && periodLabel ? ' · ' : ''}
              {periodLabel ? `Período: ${periodLabel}` : ''}
            </Typography>
            <Divider sx={{ mt: 2 }} />
          </Box>
        )}
        <TextField
          fullWidth
          label='Para confirmar, escribí "reactivar"'
          value={confirmationText}
          onChange={(event) => setConfirmationText(event.target.value)}
          placeholder="reactivar"
          autoFocus
          disabled={loading}
          error={Boolean(errorText) || (confirmationText.length > 0 && !isValid)}
          helperText={errorText || (isValid ? 'Confirmación correcta.' : 'Escribí "reactivar" para habilitar el botón.')}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={onConfirm} variant="contained" color="success" disabled={!isValid || loading}>
          Reactivar calendario
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmActivateDialog;
